import { CaretRightOutlined } from "@ant-design/icons";
import {
  AutoComplete,
  Checkbox,
  Collapse,
  Select,
  Tag,
  Tooltip,
  theme,
} from "antd";
import { useRef, useState } from "react";
import { LoadingSpin } from "./LoadingComponent";
import {
  classification_select,
  state_select,
  time_range_select,
} from "Benchmarking/Config/SelectData";
import { add_color_ratio_data } from "Benchmarking/Config/UtilFunction";
import { getSearchKeywords } from "Benchmarking/Services/Author";
import { getInstitutionSuggestSearch } from "Benchmarking/Services/Institution";
import RankTableInstitution from "./RankTableInstitution";
import { getSuggestSearchInstitutions } from "Explore/Services/Institution";
import { getSuggestKeywords } from "Explore/Services/Common";

const CollapseRankInstitution = ({
  filters,
  setFilters,
  rankData,
  isLoading,
}) => {
  const { token } = theme.useToken();
  const inputRef = useRef(null);
  const [keywordOptions, setKeywordOptions] = useState([]);
  const panelStyle = {
    marginBottom: 24,
    background: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    border: "none",
  };
  const [activeKeys, setActiveKeys] = useState(["4"]);
  const [queryValueKeyword, setQueryValueKeyword] = useState("");
  const [institutionOptions, setInstitutionOptions] = useState([]);
  const [queryValueInstitution, setQueryValueInstitution] = useState("");

  const tagRenderForSelect = (props) => {
    const { label, value, closable, onClose } = props;
    const onPreventMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };

    const isLongTag = label.length > 10;
    const tagElem = (
      <Tag
        // bordered={false}
        style={{
          background: "var(--benchmarking-color)",
          color: "white",
          userSelect: "none",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
      >
        {isLongTag ? `${label.slice(0, 10)}...` : label}
      </Tag>
    );

    return (
      <>{isLongTag ? <Tooltip title={label}>{tagElem}</Tooltip> : tagElem}</>
    );
  };

  const handleClose = (removedTag) => {
    let newTags = [];
    filters.keywords.forEach((keyword) => {
      if (keyword != removedTag) {
        newTags.push(keyword);
      }
    });
    setFilters({
      ...filters,
      keywords: newTags,
    });
  };

  const handleCloseInstitutionTags = (removedTag) => {
    let newTags = [];
    filters.institutions.forEach((institution) => {
      if (institution != removedTag) {
        newTags.push(institution);
      }
    });
    setFilters({
      ...filters,
      institutions: newTags,
    });
  };

  const handleInputChangeKeyword = (value) => {
    setQueryValueKeyword(value);
    if (value) {
      getSuggestKeywords(value, (res) => {
        setKeywordOptions(
          res.map((item) => {
            return {
              ...item,
              label: item.name,
              value: item.name,
            };
          })
        );
      });
    }
  };

  const handleInputConfirmKeyword = (value, option) => {
    if (option && !filters.keywords.some((item) => item === option.value)) {
      setFilters({
        ...filters,
        keywords: [...filters.keywords, option.value],
      });
    }
    setQueryValueKeyword("");
  };

  const handleClearInput = () => {
    setFilters({
      ...filters,
      institutionId: null,
      institutionName: null,
    });
  };

  const onChange = (value) => {
    setFilters({
      ...filters,
      time_range: value,
    });
  };
  const onChangeState = (value) => {
    setFilters({
      ...filters,
      states: value,
    });
  };
  const onChangeClassification = (value) => {
    setFilters({
      ...filters,
      classifications: value,
    });
  };
  const onChangeCheckHbcu = (e) => {
    setFilters({
      ...filters,
      hbcu: e.target.checked ? 1 : 0,
    });
  };
  const onChangeCheckHsi = (e) => {
    setFilters({
      ...filters,
      hsi: e.target.checked ? 1 : 0,
    });
  };
  const onChangeCheckMsi = (e) => {
    setFilters({
      ...filters,
      msi: e.target.checked ? 1 : 0,
    });
  };
  const onChangeCheckWomens = (e) => {
    setFilters({
      ...filters,
      womens: e.target.checked ? 1 : 0,
    });
  };
  const onChangeCheckTribal = (e) => {
    setFilters({
      ...filters,
      tribal: e.target.checked ? 1 : 0,
    });
  };

  const filterOption = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  const handleInputChangeInstitution = (value) => {
    setQueryValueInstitution(value);
    if (value) {
      getSuggestSearchInstitutions(value, (res) => {
        let option_list = res.map((item) => {
          return {
            // ...item,
            label: item.name,
            value: item.id,
          };
        });
        setInstitutionOptions(option_list);
      });
    }
  };
  const handleInputConfirmInstitution = (value, option) => {
    if (value && !filters.institutions.includes(value)) {
      const map = JSON.parse(localStorage.getItem("inst_map")) || {};
      if (!map[value]) {
        localStorage.setItem(
          "inst_map",
          JSON.stringify({
            ...map,
            [value]: option.label,
          })
        );
      }
      setFilters({
        ...filters,
        institutions: [...filters.institutions, option.value],
      });
    }
    setQueryValueInstitution("");
  };

  const FilterList = ({ filterKeys }) => {
    const valueOfKeyMapper = {
      keywords: "keyword",
      states: "state",
      time_range: "time range",
      classifications: "classification",
      institutions: "institution",
    };

    const valueOfTimeRangeMapper = {
      all: "All",
      recent: "Recent",
    };

    const renderFilterItems = () => {
      return filterKeys.map((key) => {
        const value = filters[key];
        if (Array.isArray(value) && value.length > 0) {
          return value.map((item) => (
            <Tag key={`${key}-${item}`} closable={false}>
              {`${valueOfKeyMapper[key]}: ${item}`}
            </Tag>
          ));
        } else if (typeof value === "string" && value) {
          if (key === "time_range") {
            return (
              <Tag key={`${key}-${value}`} closable={false}>
                {`${valueOfKeyMapper[key]}: ${valueOfTimeRangeMapper[value]}`}
              </Tag>
            );
          } else {
            return (
              <Tag key={`${key}-${value}`} closable={false}>
                {`${valueOfKeyMapper[key]}: ${value}`}
              </Tag>
            );
          }
        }

        return null;
      });
    };

    return <div>{renderFilterItems()}</div>;
  };

  const getItems = (panelStyle) => [
    {
      key: "1",
      label: (
        <div style={{ display: "flex", flexDirection: "row" }}>
          <p
            style={{
              color: "var(--benchmarking-color)",
              fontWeight: "600",
              fontSize: "16px",
            }}
          >
            Candidates
          </p>
          &nbsp; &nbsp;
          {!activeKeys.includes("1") && (
            <FilterList
              filterKeys={["states", "classifications", "institutions"]}
            />
          )}
        </div>
      ),
      children: (
        <div className="filters-institution">
          <div>
            {filters.institutions.length > 0 ? "Institution: " : ""}
            {filters.institutions.map((id, index) => {
              const tag =
                JSON.parse(localStorage.getItem("inst_map"))?.[id] || id;

              const isLongTag = tag.length > 20;
              const tagElem = (
                <Tag
                  key={index}
                  closable={true}
                  // bordered={false}
                  style={{
                    background: "var(--benchmarking-color)",
                    color: "white",
                    userSelect: "none",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClose={() => handleCloseInstitutionTags(tag)}
                >
                  <span>{isLongTag ? `${tag.slice(0, 20)}...` : tag}</span>
                </Tag>
              );
              return isLongTag ? (
                <Tooltip title={tag} key={index}>
                  {tagElem}
                </Tooltip>
              ) : (
                tagElem
              );
            })}
          </div>

          <div className="filters-institution-filter-section">
            <div className="position-filter">
              {/* <p className="search-title">State abbreviation</p> */}
              {/* <AutoComplete
                className="filter-item"
                allowClear
                value={queryValueInstitution}
                options={institutionOptions}
                placeholder="Enter institution name"
                onChange={handleInputChangeInstitution}
                onSelect={handleInputConfirmInstitution}
                onClear={handleClearInput}
                style={{
                  width: "200px",
                }}
              /> */}
              <Select
                className="filter-item"
                showSearch
                mode="multiple"
                placeholder="State"
                optionFilterProp="children"
                onChange={onChangeState}
                filterOption={filterOption}
                options={state_select}
                value={filters.states}
                style={{
                  width: "100px",
                }}
              />
            </div>
            <div className="institution-filter">
              {/* <p className="search-title">Carnegie Classification</p> */}
              <Select
                className="filter-item"
                mode="multiple"
                allowClear
                showSearch
                tagRender={tagRenderForSelect}
                placeholder="Classification"
                optionFilterProp="children"
                onChange={onChangeClassification}
                filterOption={filterOption}
                options={classification_select}
                style={{
                  width: "350px",
                }}
              />
            </div>
          </div>
          <Checkbox onChange={onChangeCheckHbcu} checked={filters.hbcu}>
            HBCU
          </Checkbox>
          <Checkbox onChange={onChangeCheckHsi} checked={filters.hsi}>
            HSI
          </Checkbox>
          <Checkbox onChange={onChangeCheckMsi} checked={filters.msi}>
            MSI
          </Checkbox>
          <Checkbox onChange={onChangeCheckWomens} checked={filters.womens}>
            Womens
          </Checkbox>
          <Checkbox onChange={onChangeCheckTribal} checked={filters.tribal}>
            Tribal
          </Checkbox>
        </div>
      ),
      style: panelStyle,
    },
    {
      key: "2",
      label: (
        <div style={{ display: "flex", flexDirection: "row" }}>
          <p
            style={{
              color: "var(--benchmarking-color)",
              fontWeight: "600",
              fontSize: "16px",
            }}
          >
            Target Area
          </p>
          &nbsp; &nbsp;
          {!activeKeys.includes("2") && (
            <FilterList filterKeys={["keywords"]} />
          )}
        </div>
      ),
      children: (
        <div>
          <div className="keys">
            {filters.keywords.map((tag, index) => {
              const isLongTag = tag.length > 20;
              const tagElem = (
                <Tag
                  key={index}
                  closable={true}
                  style={{
                    background: "var(--benchmarking-color)",
                    color: "white",
                    userSelect: "none",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClose={() => handleClose(tag)}
                >
                  <span>{isLongTag ? `${tag.slice(0, 20)}...` : tag}</span>
                </Tag>
              );
              return isLongTag ? (
                <Tooltip title={tag} key={index}>
                  {tagElem}
                </Tooltip>
              ) : (
                tagElem
              );
            })}
          </div>
          <div
            style={{
              width: "100%",
            }}
          >
            <AutoComplete
              ref={inputRef}
              options={keywordOptions}
              value={queryValueKeyword}
              placeholder="Add more keywords"
              onChange={handleInputChangeKeyword}
              onSelect={handleInputConfirmKeyword}
              style={{
                width: "500px",
                height: "35px",
                margin: "3px",
              }}
            />
          </div>
        </div>
      ),
      style: panelStyle,
    },
    {
      key: "3",
      label: (
        <div style={{ display: "flex", flexDirection: "row" }}>
          <p
            style={{
              color: "var(--benchmarking-color)",
              fontWeight: "600",
              fontSize: "16px",
            }}
          >
            Time Range
          </p>
          &nbsp; &nbsp;
          {!activeKeys.includes("3") && (
            <FilterList filterKeys={["time_range"]} />
          )}
        </div>
      ),
      children: (
        <div>
          <Select
            style={{ width: "250px" }}
            placeholder="Select time range"
            optionFilterProp="children"
            onChange={onChange}
            options={time_range_select}
            value={filters.time_range}
          />
        </div>
      ),
      style: panelStyle,
    },
    {
      key: "4",
      label: (
        <p
          style={{
            color: "var(--benchmarking-color)",
            fontWeight: "600",
            fontSize: "16px",
          }}
        >
          Ranking result
        </p>
      ),
      children: (
        // rankData.length > 0 ? (
        //   <RankTableInstitution data={add_color_ratio_data(rankData)} />
        // ) : (
        //   <div></div>
        // ),
        <LoadingSpin
          data={rankData ? rankData : []}
          style={{
            width: "100%",
          }}
          isLoading={isLoading}
          component={
            // <RankTableFaculty data={add_color_ratio_data(rankData)} />
            rankData && rankData.length > 0 ? (
              <RankTableInstitution data={add_color_ratio_data(rankData)} />
            ) : (
              <div></div>
            )
          }
        />
      ),
      style: panelStyle,
    },
  ];
  return (
    <Collapse
      bordered={false}
      activeKey={activeKeys}
      onChange={(keys) => {
        setActiveKeys(keys);
      }}
      expandIcon={({ isActive }) => (
        <CaretRightOutlined rotate={isActive ? 90 : 0} />
      )}
      style={{
        background: token.colorBgContainer,
      }}
      items={getItems(panelStyle)}
    />
  );
};

export default CollapseRankInstitution;
